export const FREE_DELIVERY = 'FREE';
export const UK_DROPDOWN_OPTIONS_LABEL = 'United Kingdom';
export const OTHER_COUNTRIES_DROPDOWN_OPTIONS_LABEL = 'Other countries';
